import React, { useState, useRef, useEffect, useCallback } from "react";
import { DatePicker, Space } from 'antd';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { PieChart, Pie, Cell } from "recharts";
import avergecycleImages from "../../assests/images/averagecycle.png";
import completionImages from "../../assests/images/completion.png";
import submissionImages from "../../assests/images/submission.png";
import averageapprovelImages from "../../assests/images/aaverage approval.png";
import dropoffImages from "../../assests/images/dropoff.png";
import rattingupImages from "../../assests/images/Rattingup (2).png";
import rattingdownImages from "../../assests/images/Rattingdown (2).png";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,BarChart,Bar,Rectangle } from 'recharts';
import CustomSearchDropdown from "../common/customSearchDropdown";
import { rfqServices } from "../../services/rfqServices";
import { isEmptyDash, strToDateYYMMDD } from "../../constant";
import { adminServices } from "../../services/adminServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _ from "lodash";
import { dbResObj } from "../../constant/dummyData2";
import TableListingWithoutDnD from "../common/tableListingWithoutDnD";
import { vendorServices } from "../../services/vendorServices";
import { useNavigate } from "react-router-dom";

const initialDBData = {
  documentSubmissionTime: {monthlyData: [],},
  internalApprovalTime: {monthlyData: [],},
  onboardingCompletionRate: {monthlyData: [],},
  onboardingCycleTime: {monthlyData: [],},
}

const kpiDataInit = [
  {
    value: "",
    unit:"",
    kpiName: "Average Cycle Time",
    ratingImage: rattingupImages,
    ratingPercentage:"12%",
    month: "This Month",
    vendorImage:avergecycleImages,
    key: "onboardingCycleTime",
  },
  {
    value: "",
    unit:"",
    kpiName: "Vendor Completion Rate",
    ratingImage: rattingupImages,
    ratingPercentage:"12%",
    month: "This Month",
    vendorImage:completionImages,
    key: "onboardingCompletionRate",
  },
  {
    value: "",
    unit:"",
    kpiName: "Average Submission Time",
    ratingImage: rattingdownImages,
    ratingPercentageone:"10%",
    month: "This Month",
    vendorImage:submissionImages,
    key: "documentSubmissionTime",
  },
  {
    value: "",
    unit:"",
    kpiName: "Average Approval Time",
    ratingImage: rattingdownImages,
    ratingPercentageone:"23%",
    month: "This Month",
    vendorImage:averageapprovelImages,
    key: "internalApprovalTime",
  },
  {
    value: "",
    unit:"",
    kpiName: "Drop Off Rate",
    ratingImage: rattingupImages,
    ratingPercentage:"19%",
    month: "This Month",
    vendorImage:dropoffImages,
    key: "vendorDropOffRate",
  },
  
];
      
let vendordropoffdataInit = [
  { name: 'Jan', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Feb', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Mar', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Apr', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'May', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Jun', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Jul', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Aug', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Sep', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Oct', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Nov', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
  { name: 'Dec', VendorsCompleted: 0, DropOffRate: 0, amt: 0 },
];

const vendorOBCycleTimeInit = [
  { name: 'Jan', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Feb', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Mar', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Apr', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'May', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Jun', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Jul', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Aug', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Sep', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Oct', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Nov', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Dec', AverageCycleTime: 0, MinCycleTime: 0, MaxCycleTime: 0 },
];

const submitdocumentdataInit = [
  { name: 'Jan', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Feb', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Mar', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Apr', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'May', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Jun', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Jul', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Aug', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Sep', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Oct', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Nov', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
  { name: 'Dec', MaxSubmissionTime: 0, AverageSubmissionTime: 0, MinSubmissionTime: 0 },
];
const approvalbarchartdataInit = [
  { name: 'Jan', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Feb', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Mar', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Apr', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'May', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Jun', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Jul', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Aug', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Sep', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Oct', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Nov', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
  { name: 'Dec', MinApprovalTime: 0, MaxApprovalTime: 0, AverageApprovalTime: 0 },
];
const vendorOBCompletionRateInit = [
  { name: 'Jan', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Feb', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Mar', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Apr', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'May', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Jun', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Jul', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Aug', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Sep', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Oct', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Nov', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
  { name: 'Dec', TotalVendorsInvited: 0, CompletionRate: 0, TotalVendorsCompleted: 0 },
];

const initialColumns = [
  { id: "index", label: "S.No.", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "vendorId", label: "Vendor Id", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "vendorName", label: "Vendor Name", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "registrationDate", label: "Registration Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "sdfsdf", label: "Category", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "emailAddress", label: "Email Address", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "state", label: "State", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "sdfsdf", label: "Assignee Name", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "finalStatus", label: "Final Status", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "onboardingType", label: "Onboarding type", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "error", label: "Error Msg (If failed)", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "col10", label: "Actions", isSort: false, sortLabel: "", formate: "Redirect_Btn", redirectUrl:"/admin/vendor-list-details", redirectKeyName: "_id" },
];

function VendorOnboardingDasboardTab(props) {
  const [selectedObj, setSelectedObj] = useState(null);
  const [vendorOBCycleTime, setVendorOBCycleTime] = useState(vendorOBCycleTimeInit);
  const [vendorOBCompletionRate, setVendorOBCompletionRate] = useState(vendorOBCompletionRateInit);
  const [submitdocumentdata, setSubmitdocumentdata] = useState(submitdocumentdataInit);
  const [approvalbarchartdata, setApprovalbarchartdata] = useState(approvalbarchartdataInit);
  const [vendordropoffdata, setVendordropoffdata] = useState(vendordropoffdataInit);
  const [newDateRange, setNewDateRange] = useState({ from: "", to: "" });
  const [newValidityPeriod, setNewValidityPeriod] = useState("");

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [vendorOBData, setVendorOBData] = useState(initialDBData);
  const [kpiData, setKPIData] = useState(kpiDataInit);

    const disabledDate = (current) => {
        return current && current < new Date().setHours(0, 0, 0, 0);
    };

  useEffect(() => {
    getDashboardOBData("");   
  }, []);
  
  useEffect(() => {
    if (props?.count > 0) {
      // console.log("sdfsdf", props?.count); 
      let str = isEmptyDash(selectedObj?.selectedValue) ? "" : selectedObj?.selectedValue;
      getDashboardOBData(str);
    }     
  }, [props?.count]);
    
  const onSearchSelectChange = (param) => {
    // console.log(param);      
    setSelectedObj(param);
    
    // setSelectedVendor(param?.selectedValue);
    // setSelectedPO("");
    // setPendingPO(pendingPOInit);
    // setPOProductsListing(productListInit);
  }
  
  const clearData = (param) => {
    setSelectedObj({selectedLable: "", selectedValue: ""}); 
    getDashboardOBData("");   
  }

  const handleNewDatePickerChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      setNewDateRange({
        from: dateStrings[0],
        to: dateStrings[1]
      });

      // const fromDate = new Date(dateStrings[0]);
      // const toDate = new Date(dateStrings[1]);
      // const differenceInTime = toDate.getTime() - fromDate.getTime();
      // const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      // if (differenceInDays < 30) {
      //   setNewValidityPeriod(`${differenceInDays} Days`);
      // } else {
      //   const differenceInMonths = differenceInDays / 30;
      //   const differenceInYears = differenceInMonths / 12;
      //   setNewValidityPeriod(`${differenceInYears.toFixed(1)} Years`);
      // }
    }
  };

  const getUnit = (data) => {
    if (data.unit == "percentage") {
      return "%";
    }
    return data.unit;
  } 

  const getDashboardOBData = (vendorId) => {
    let newDate = new Date();
    let newYear = newDate.getFullYear();
    newDateRange["from"] = `${newYear}-01-01`;
    newDateRange["to"] = `${newYear}-12-31`;
    
    // newDateRange["from"] = getConvertedDate(newDateRange["from"]);
    // newDateRange["to"] = getConvertedDate(newDateRange["to"]);
    
    let bodyData = {
      "vendorId": vendorId,
      "dateRange": {
          "startDate": newDateRange?.from,
          "endDate": newDateRange?.to,
      }
    }; 
    // console.log(bodyData); 
    
    setIsLoading(true);
    let promise = adminServices.adminDashboardOB(bodyData);
    promise.then((res) => {
      if (res.data.success === true) {
        let data = res?.data?.data;
        // let data = dbResObj?.data;
        setVendorOBData(data);
        props?.addNewTime(new Date());
        let vendorOBCycleTimeInit1 = _.cloneDeep(vendorOBCycleTimeInit);
        let vendorOBCompletionRateInit1 = _.cloneDeep(vendorOBCompletionRateInit);
        let submitdocumentdataInit1 = _.cloneDeep(submitdocumentdataInit);
        let approvalbarchartdataInit1 = _.cloneDeep(approvalbarchartdataInit);
        let vendordropoffdataInit1 = _.cloneDeep(vendordropoffdataInit);
          
        let kpiData1 = _.cloneDeep(kpiData);
        for (let i = 0; i < kpiData1.length; i++) {          
          if (kpiData1[i]?.key == "documentSubmissionTime" ) {
            kpiData1[i].value = data["documentSubmissionTime"]["averageSubmissionTime"];
            kpiData1[i].unit = getUnit(data["documentSubmissionTime"]);
          }          
          if (kpiData1[i]?.key == "internalApprovalTime" ) {
            kpiData1[i].value = data["internalApprovalTime"]["averageApprovalTime"];
            kpiData1[i].unit = getUnit(data["internalApprovalTime"]);
          }          
          if (kpiData1[i]?.key == "onboardingCompletionRate" ) {
            kpiData1[i].value = data["onboardingCompletionRate"]["completionRate"];
            kpiData1[i].unit = getUnit(data["onboardingCompletionRate"]);
          }          
          if (kpiData1[i]?.key == "onboardingCycleTime" ) {
            kpiData1[i].value = data["onboardingCycleTime"]["averageCycleTime"];
            kpiData1[i].unit = getUnit(data["onboardingCycleTime"]);
          }         
          if (kpiData1[i]?.key == "vendorDropOffRate" ) {
            kpiData1[i].value = data["vendorDropOffRate"]["dropOffRate"];
            kpiData1[i].unit = getUnit(data["vendorDropOffRate"]);
          }
        }

        // For OB Cycle Time
        for (let j = 0; j < vendorOBCycleTimeInit1.length; j++) {
          vendorOBCycleTimeInit1[j]["AverageCycleTime"] = 0;
          vendorOBCycleTimeInit1[j]["MaxCycleTime"] = 0;
          vendorOBCycleTimeInit1[j]["MinCycleTime"] = 0;
          for (let k = 0; k < data?.onboardingCycleTime?.monthlyData.length; k++) {
            if (j == data?.onboardingCycleTime?.monthlyData[k]?.month - 1) {
              vendorOBCycleTimeInit1[j]["AverageCycleTime"] = data?.onboardingCycleTime?.monthlyData[k]?.averageCycleTime;
              vendorOBCycleTimeInit1[j]["MaxCycleTime"] = data?.onboardingCycleTime?.monthlyData[k]?.maxCycleTime;
              vendorOBCycleTimeInit1[j]["MinCycleTime"] = data?.onboardingCycleTime?.monthlyData[k]?.minCycleTime;              
            }
          }
        }

        // For OB Completion Rate
        for (let j = 0; j < vendorOBCompletionRateInit1.length; j++) {
          vendorOBCompletionRateInit1[j]["amt"] = 0;
          vendorOBCompletionRateInit1[j]["pv"] = 0;
          vendorOBCompletionRateInit1[j]["uv"] = 0;
          for (let k = 0; k < data?.onboardingCompletionRate?.monthlyData.length; k++) {
            if (j == data?.onboardingCompletionRate?.monthlyData[k]?.month - 1) {
              vendorOBCompletionRateInit1[j]["amt"] = data?.onboardingCompletionRate?.monthlyData[k]?.completionRate;
              vendorOBCompletionRateInit1[j]["pv"] = data?.onboardingCompletionRate?.monthlyData[k]?.totalVendorsInvited;
              vendorOBCompletionRateInit1[j]["uv"] = data?.onboardingCompletionRate?.monthlyData[k]?.totalVendorsCompleted;              
            }
          }
        }

        // For Submission Doc
        for (let j = 0; j < submitdocumentdataInit1.length; j++) {
          submitdocumentdataInit1[j]["AverageSubmissionTime"] = 0;
          submitdocumentdataInit1[j]["MaxSubmissionTime"] = 0;
          submitdocumentdataInit1[j]["MinSubmissionTime"] = 0;
          for (let k = 0; k < data?.documentSubmissionTime?.monthlyData.length; k++) {
            if (j == data?.documentSubmissionTime?.monthlyData[k]?.month - 1) {
              submitdocumentdataInit1[j]["AverageSubmissionTime"] = data?.documentSubmissionTime?.monthlyData[k]?.averageSubmissionTime;
              submitdocumentdataInit1[j]["MaxSubmissionTime"] = data?.documentSubmissionTime?.monthlyData[k]?.maxSubmissionTime;
              submitdocumentdataInit1[j]["MinSubmissionTime"] = data?.documentSubmissionTime?.monthlyData[k]?.minSubmissionTime;              
            }
          }
        }

        // For Internal Approval Rate
        for (let j = 0; j < approvalbarchartdataInit1.length; j++) {
          approvalbarchartdataInit1[j]["AverageApprovalTime"] = 0;
          approvalbarchartdataInit1[j]["MaxApprovalTime"] = 0;
          approvalbarchartdataInit1[j]["MinApprovalTime"] = 0;
          for (let k = 0; k < data?.internalApprovalTime?.monthlyData.length; k++) {
            if (j == data?.internalApprovalTime?.monthlyData[k]?.month - 1) {
              approvalbarchartdataInit1[j]["AverageApprovalTime"] = data?.internalApprovalTime?.monthlyData[k]?.averageApprovalTime;
              approvalbarchartdataInit1[j]["MaxApprovalTime"] = data?.internalApprovalTime?.monthlyData[k]?.maxApprovalTime;
              approvalbarchartdataInit1[j]["MinApprovalTime"] = data?.internalApprovalTime?.monthlyData[k]?.minApprovalTime;              
            }
          }
        }

        // For Vendor Drop-off Rate
        for (let j = 0; j < vendordropoffdataInit1.length; j++) {
          vendordropoffdataInit1[j]["DropOffRate"] = 0;
          vendordropoffdataInit1[j]["VendorsCompleted"] = 0;
          vendordropoffdataInit1[j]["amt"] = 0;

          for (let k = 0; k < data?.vendorDropOffRate?.monthlyData.length; k++) {
            if (j == data?.vendorDropOffRate?.monthlyData[k]?.month - 1) {
              vendordropoffdataInit1[j]["DropOffRate"] = data?.vendorDropOffRate?.monthlyData[k]?.dropOffRate;
              vendordropoffdataInit1[j]["VendorsCompleted"] = data?.vendorDropOffRate?.monthlyData[k]?.vendorsCompleted;
              vendordropoffdataInit1[j]["amt"] = data?.vendorDropOffRate?.monthlyData[k]?.vendorsStarted;              
            }
          }          
        }

        // console.log(data, vendordropoffdataInit1);
        
        setVendorOBCycleTime(vendorOBCompletionRateInit1);
        setVendorOBCompletionRate(vendorOBCompletionRateInit1);
        setSubmitdocumentdata(submitdocumentdataInit1);
        setApprovalbarchartdata(approvalbarchartdataInit1);
        setVendordropoffdata(vendordropoffdataInit1);

        setKPIData(kpiData1);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
    .catch(function (error) {
      console.log(error);
      setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
    })
    .finally((param) => {
      setIsLoading(false);
    });
  };

  const getConvertedDate = (param) => {
    if (isEmptyDash(param)) {
      return "";
    } else {
      return param.split("-").reverse().join("-");
    }
  };

  return (
 <>


 
 <div class="login-forms">
 <div class="text-centers">
 <div className="main_row_bidding_vendordonbdasboard">
            <div>
              <div className="required_react_vendor_block_dashboard">
                <label className="row_div_box_select_dashboard">Vendor ID</label>

                <div className="dashboard_site_select">
                    <CustomSearchDropdown 
                        // column={initialColumns}
                        listingArrName="vendors"
                        onSearchSelectChange={onSearchSelectChange}
                        promiseRequest={rfqServices.getExistingVendorRfqListing}
                        extraPromiseParam="poExists=true"
                        additionalData={{
                          lableKeyName1: "vendorName",
                          lableKeyName2: "",
                          valueKeyName: "_id",
                        }} 
                        // isDisable={(details?.assigneeId != UserObj?._id)}  
                        defaultValue={selectedObj}           
                      />
                  
                </div>
              </div>
            </div>
            <div>
                  {/* <div className="required_react_vendor_block_dashboard">
                      <div className="datepicker_vendor_dashoard">
                      <label className="row_div_box_select_dashboard">Start Date </label>
                      <label className="row_div_box_select_dashboard">End Date</label>
                      </div>
                      <div class="lets_modal_vendor">
                      <div class="col-sm-7">
                      <Space direction="vertical" size={20}>
                      

                          <DatePicker.RangePicker 
                            className="datepicker_widthdashboard" 
                            getPopupContainer={trigger => trigger.parentNode} 
                            placement="bottomLeft" 
                            onChange={handleNewDatePickerChange} 
                            disabledDate={disabledDate} 
                            format="DD-MM-YYYY" 
                          />

                      </Space>
                      <div
                      class="error-message"
                      id="currentContactNameError"></div>
                      </div>
                  </div>
              </div> */}
 
            </div>
            <div className="invoicing_dashboard_btns">
              <button type="button" class="btn btn-success save_next_btns" onClick={() => getDashboardOBData(selectedObj?.selectedValue)}>
                Apply
              </button>
              <button type="button" class="btn clear_btn_status_block_lists" style={{marginLeft: "10px"}} onClick={clearData}>
                Clear
              </button>
            </div>
          
          </div>
          <div className="vendor_dasboard_maine_box_row2">
           {
              kpiData.map((kpi,i) => (
                <div key={i} className="bpdt_row1_box11">
                  <div className="bpdt_row1_box1_left">
                    <div>
                      <div className="pad_marg_row">
                      <h1 className="noPadMarg percentage_vendor_dashboard_body">{kpi?.value}</h1>
                      <span className="days_percentage_name">{kpi?.unit}</span>
                      </div>
                      <p className="noPadMarg Participated_bpdt_div">
                        {kpi?.kpiName}
                      </p>
                    </div>
                    <div className="bpdt_row1_box1_left_row2">
                      <div className="bpdt_row1_block">
                        <img src={kpi?.ratingImage} alt="" />
                        <p className="rating_color">{kpi?.ratingPercentage}</p>
                        <p className="rating_color_down">{kpi?.ratingPercentageone}</p>
                        <p>{kpi?.month}</p>
                      </div>
                    </div>
                  </div>
                  <div className="avergecyle_imges_body">
                    <MoreVertIcon />
                    <img src={kpi?.vendorImage} alt="" className="avergecyle_imges" />
                  </div>
                </div>
              ))
            }
  </div>
  <div className="vendor_dashboard_onboarding_graph_row">
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Vendor Onboarding Cycle Time</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={vendorOBCycleTime}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="AverageCycleTime" stroke="#A700FF" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="MinCycleTime" stroke="#3CD856" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="MaxCycleTime" stroke="#EF4444" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
      </LineChart>
    </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Vendor Onboarding Completion Rate</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={320}>
      <BarChart className="ResponsiveContainer_vendor_dashboard"
        data={vendorOBCompletionRate}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name"  />
        <YAxis />
        <Tooltip  />
        <Legend  />
        <Bar className="responsive_vendor_dashboard" dataKey="CompletionRate" fill="#9BBB58" shape={<Rectangle fill="#9BBB58" />} />
        <Bar className="responsive_vendor_dashboard" dataKey="TotalVendorsInvited" fill="#9BBB58" shape={<Rectangle fill="#9BBB58" />} />
        <Bar className="responsive_vendor_dashboard" dataKey="TotalVendorsCompleted" fill="#9BBB58" shape={<Rectangle fill="#9BBB58" />} />
      </BarChart>
    </ResponsiveContainer>
</div>
  </div>
  <div className="vendor_dashboard_secondbody_row">
  <div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Time to Submit Documents</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={submitdocumentdata}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="AverageSubmissionTime" stroke="#3CD856" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
        <Line yAxisId="left" type="monotone" dataKey="MaxSubmissionTime" stroke="#FEC321" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
        <Line yAxisId="left" type="monotone" dataKey="MinSubmissionTime" stroke="#59E6F6" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
      </LineChart>
    </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Internal Approval Time</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart className="dashboard_barchart" data={approvalbarchartdata}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="MaxApprovalTime" stackId="a" fill="#695EEF" />
        <Bar dataKey="AverageApprovalTime" stackId="a" fill="#11D1B7" />
        <Bar dataKey="MinApprovalTime" stackId="a" fill="#FFC061" />
    </BarChart>
</ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Vendor Drop-off Rate</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
        <BarChart className="dashboard_barchart"
          width={500}
          height={300}
          data={vendordropoffdata}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="DropOffRate" stackId="a" fill="#EF4444" />
          <Bar dataKey="VendorsCompleted" stackId="a" fill="#0095F6" />
        </BarChart>
      </ResponsiveContainer>
</div>
  </div>
        <div className="table_row_dashboard_body_main2">
            <div className="admin_dashboard_row_participation_here">
              <h4 className="text_vendors_dashboard_inpie">All Vendors Participation</h4>
              <div className="admin_dashboard_row_right_table">
                {/* <div class="search_main">
                  <div id="custom-search-input">
                    <div className="input-group col-md-12">
                      <input
                        type="text"
                        className="form-control input-lg"
                        placeholder="Search here"
                        fdprocessedid="8achb"
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-info btn-lg"
                          type="button"
                          fdprocessedid="trsp06"
                        >
                          <span className="glyphicon glyphicon-search">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div> */}
                <button className="btn_bpdt_view_row_bidding_dash" onClick={() => navigateUrl(`/admin/vendor-list`)}>
                  View all Vendors
                </button>
              </div>
            </div>


            <div className="listing_main_row_dashboard_bpdt_block">
              
            <TableListingWithoutDnD
                column={initialColumns}
                listingArrName="vendors"
                filterKeyName={""}
                componentName="Vendor_List"
                promiseRequest={vendorServices.getVendorList}
                promiseUrlType="LIST"
                additionalData={{
                  isMaster: false,
                  type: "Vendor_List",
                  isTrackOrder: false,
                  isFilter: false,
                  isSearch: false,
                  isSort: false,
                  isPagePerSize: false,
                  isPagination: false,
                  isDragable: false,
                }}
            />

            </div>
            
          </div>
</div>
 </div>
 
 
        <AlertComponent
            alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => 999999,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
 
 </>
  )
}

export default VendorOnboardingDasboardTab